import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-screen h-screen bg-white flex items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "animate-loading-spin w-20"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}